import React from 'react';
import ImageDropzone from './ImageDropzone';

const DropzoneBanner = ({ onBannerDropHandler, bannerPath }) => (
  <ImageDropzone
    inputName="bannerImage"
    label="Banner Image"
    imagePath={bannerPath}
    alt="Banner"
    onImageReady={onBannerDropHandler}
    prepareOptions={{ maxSize: 700, preservePng: true }}
  />
);

export default DropzoneBanner;
